
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.69241 0.0650924L13.9351 4.30773L11.6117 5.21687L8.2782 9.96459L8.07617 12.995L5.24774 10.1666L0.500024 13.5001L3.83353 8.7524L1.0051 5.92398L4.03556 5.72195L8.78327 2.38844L9.69241 0.0650924Z","fill":"#00A769"}})])
          )
        }
      }
    